import Vue from 'vue';
import ClickOutside from 'v-click-outside';

Vue.use(ClickOutside);
